module.exports = __webpack_public_path__ + "img/3-3.19521fc1.png";